<template>
  <Dropdown
    ref="dropdown"
    transfer
    :placement="placement"
    @on-click="handleClick"
  >
    <a
      class="drop-menu-a"
      type="text"
      :style="{ textAlign: !hideTitle ? 'left' : '' }"
      @mouseover="handleMouseMove($event, children)"
    >
      <Icon :type="parentItem.icon" :color="'#fff'" :size="iconSize"></Icon>
      <span class="menu-title" v-if="!hideTitle">{{
        showTitle(parentItem)
      }}</span>
      <Icon
        style="float: right"
        v-if="!hideTitle"
        type="ios-arrow-forward"
        :size="16"
      />
    </a>
    <DropdownMenu ref="dropdown" slot="list">
      <template v-for="child in children">
        <sider-menu-shrink
          v-if="showChildren(child)"
          :icon-size="iconSize"
          :parent-item="child"
          :key="`drop-${child.name}`"
        >
        </sider-menu-shrink>
        <DropdownItem v-else :key="`drop-${child.name}`" :name="child.name">
          <Icon :type="child.icon" :size="iconSize"></Icon>
          <span class="menu-title">{{ showTitle(child) }}</span>
        </DropdownItem>
      </template>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
import mixin from './mixin.js';
import itemMixin from './item-mixin.js';
import { findNodeUpperByClasses } from '../menu-util';

export default {
  name: 'SiderMenuShrink',
  mixins: [mixin, itemMixin],
  props: {
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      placement: 'right-end', // 控制下拉菜单显示位置
    };
  },
  methods: {
    handleClick(name) {
      this.$emit('on-click', name);
    },

    // 显示不同 placement 位置
    handleMouseMove(event, children) {
      const { pageY } = event;
      const height = children.length * 38;
      const isOverflow = pageY + height < window.innerHeight;
      this.placement = isOverflow ? 'right-start' : 'right-end';
    },
  },
  mounted() {
    let dropdown = findNodeUpperByClasses(this.$refs.dropdown.$el, [
      'ivu-select-dropdown',
      'ivu-dropdown-transfer',
    ]);
    if (dropdown) dropdown.style.overflow = 'visible';
  },
};
</script>

<style lang="less" scoped>
a.drop-menu-a {
  display: inline-block;
  padding: 6px 15px;
  width: 100%;
  text-align: center;
  color: #fff;
}
</style>
